<template>
  <div v-if="!hasBookedSeatsInSelection" class="phone-viewport">
    <div class="font-bold p-2 flex">Grouping</div>
    <div v-if="oneCategorySelected && seatsSelected" class="space-y-2 p-2 flex flex-col">
      <div class="grid grid-cols-2 gap-1">
        <template v-if="moreThanOneSeatSelected">
          <SMButton v-tippy="'Group seats together'" filled type="primary" @click="toggleGrouping(true)">
            Group
          </SMButton>
          <SMButton v-tippy="'Ungroup seats'" filled type="danger" @click="toggleGrouping(false)">Ungroup</SMButton>
        </template>
        <template v-if="(moreThanOneSeatSelected && tableSelected) || seatsOrTableSeatsSelected">
          <SMButton filled type="primary" @click="toggleDisabling(false)">Enable</SMButton>
          <SMButton filled type="danger" @click="toggleDisabling(true)">Disable</SMButton>
        </template>
      </div>
      <div v-if="moreThanOneSeatSelected" class="space-y-2 px-2 py-4 md-dense">
        <div class="grid gap-2 items-center" style="grid-template-columns: auto 1fr">
          <div v-tippy="'Gouped Seats'" class="flex-shrink-0">Seats</div>
          <SMInput v-model.lazy.trim="numberOfSeats" />

          <div v-tippy="'Space between seats'" class="flex-shrink-0">Space</div>
          <SMInput v-model.lazy.trim="numberOfDisabled" />
        </div>

        <div v-if="!tableSeatsSelected">
          <div class="switch-wrapper">
            <SMSwitch v-model="checkerBoardOrder" class="md-primary md-list-action">Disable front and back</SMSwitch>
          </div>
        </div>

        <div class="flex gap-2 items-center">
          <div class="switch-wrapper">
            <SMSwitch v-model="reverseOrder" class="md-primary md-list-action">Reverse</SMSwitch>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="space-y-2 p-2 md-dense">
      <div class="flex gap-2 items-center">
        <div>
          <span><SMIcon icon="warning" /></span>
          <span>Please select seats with one assigned category</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import eventbus from 'tiny-emitter/instance';
import forEach from 'lodash/forEach';
import first from 'lodash/first';
import SMIcon from '@/components/ui/SMIcon.vue';

import { FLIP, EVENTSTATUS, TABLE, SEATSTATUS, TYPE } from '@/constants';
import SMInput from '@/components/ui/SMInput.vue';
import SMButton from '@/components/ui/SMButton.vue';

export default {
  components: {
    SMIcon,
    SMInput,
    SMButton,
  },
  data() {
    return {
      isCheckerBoardOrder: false,
      isReverseOrder: false,
      groupSize: 1,
      spaceBetweenGroup: 0,
    };
  },
  props: ['selection'],
  methods: {
    toggleDisabling(value) {
      if (value) {
        this.selection.items.forEach((seat) => {
          if (seat.type != TYPE.TABLE) {
            seat.disable();
          }
        });
      } else {
        this.selection.items.forEach((seat) => {
          if (seat.type != TYPE.TABLE) {
            seat.enable();
          }
        });
      }
      this.$app.seatmap.triggerUnsavedChanges(true);
    },
    toggleGrouping(value) {
      if (value) {
        let newGroupId = this.$app.seatmap.groupIdCounter++;
        this.selection.items.forEach((seat) => {
          if (seat.type != TYPE.TABLE) {
            seat.placeToGroup(newGroupId);
          }
        });
      } else {
        this.selection.items.forEach((seat) => {
          if (seat.type != TYPE.TABLE) {
            seat.removeFromPreviousGroup();
          }
        });
      }
      this.$app.seatmap.triggerUnsavedChanges(true);
    },
  },
  computed: {
    moreThanOneSeatSelected() {
      return this.selection.items.length > 1;
    },
    isRoundedTableSelected() {
      return this.selection.items.find((u) => u.type === TYPE.TABLESEAT && u.table.subtype === TYPE.TABLE_ROUNDED);
    },
    tableSelected() {
      return this.selection.items.find((u) => u.type === TYPE.TABLE);
    },
    tableSeatsSelected() {
      return this.selection.items.find((u) => u.type === TYPE.TABLESEAT);
    },
    seatsSelected() {
      return this.selection.items.find(
        (u) => u.type === TYPE.SEAT || u.type === TYPE.TABLESEAT || u.type === TYPE.TABLE
      );
    },
    seatsOrTableSeatsSelected() {
      return this.selection.items.find((u) => u.type === TYPE.SEAT || u.type === TYPE.TABLESEAT);
    },
    oneCategorySelected() {
      if (this.seatsSelected) {
        let categories = [];
        let uniqueArray = [];
        this.selection.items.forEach((item) => {
          let fitem = item;
          if (item.type === TYPE.SEAT || item.type === TYPE.TABLESEAT || item.type === TYPE.TABLE) {
            if (item.type === TYPE.TABLE) {
              fitem = first(item.seats);
            }
          }
          if (fitem.category !== undefined && fitem.category !== '') {
            categories.push(fitem.category);
          } else {
            categories.push('empty');
          }
        });
        if (categories.length > 0) {
          uniqueArray = [...new Set(categories)];
        }
        return uniqueArray.length == 1 && uniqueArray[0] !== 'empty';
      }
      return true;
    },
    hasBookedSeatsInSelection() {
      let bookedUnits = 0;
      if (this.selection.items.length > 0) {
        this.selection.items.forEach((u) => {
          if (u.type === TYPE.SEAT || u.type === TYPE.TABLESEAT) {
            bookedUnits +=
              u.attributes.status === SEATSTATUS.OCCUPIED || u.attributes.status === SEATSTATUS.RESERVED || u.inCart
                ? 1
                : 0;
          } else if (u.type === TYPE.TABLE) {
            const bookedTableSeats = u.seats.filter(
              (s) =>
                s.attributes.status === SEATSTATUS.OCCUPIED || s.attributes.status === SEATSTATUS.RESERVED || s.inCart
            );
            bookedUnits += bookedTableSeats.length > 0 ? 1 : 0;
          }
        });
      }
      return !!bookedUnits;
    },
    checkerBoardOrder: {
      get: function () {
        return this.isCheckerBoardOrder;
      },
      set: function (newValue) {
        this.isCheckerBoardOrder = newValue;
        eventbus.emit('selection:group-space', {
          spaceBetweenGroup: this.spaceBetweenGroup,
          groupSize: this.groupSize,
          reverse: this.reverseOrder,
          checkerBoardOrder: this.isCheckerBoardOrder,
        });
      },
    },
    reverseOrder: {
      get: function () {
        return this.isReverseOrder;
      },
      set: function (newValue) {
        this.isReverseOrder = newValue;
        eventbus.emit('selection:group-space', {
          spaceBetweenGroup: this.spaceBetweenGroup,
          groupSize: this.groupSize,
          reverse: this.isReverseOrder,
          checkerBoardOrder: this.isCheckerBoardOrder,
        });
      },
    },
    numberOfSeats: {
      get: function () {
        return this.groupSize;
      },
      set: function (newValue) {
        this.groupSize = Number.parseInt(newValue) || 1;
        eventbus.emit('selection:group-space', {
          spaceBetweenGroup: this.spaceBetweenGroup,
          groupSize: this.groupSize,
          reverse: this.reverseOrder,
          checkerBoardOrder: this.checkerBoardOrder,
        });
      },
    },
    numberOfDisabled: {
      get: function () {
        return this.spaceBetweenGroup;
      },
      set: function (newValue) {
        this.spaceBetweenGroup = Number.parseInt(newValue) || 0;
        eventbus.emit('selection:group-space', {
          spaceBetweenGroup: this.spaceBetweenGroup,
          groupSize: this.groupSize,
          reverse: this.reverseOrder,
          checkerBoardOrder: this.checkerBoardOrder,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
